var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Badge',{staticClass:"me-1",attrs:{"color":"dark"}},[_c('Icon',{attrs:{"icon":"tag"}}),_vm._v(" "),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }